var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"programs_clickbox",attrs:{"href":_vm.link,"target":"_blank"}},[_c('div',{staticClass:"programs_card m2 p2"},[_c('img',{staticClass:"program_icons",attrs:{"src":_vm.icon,"alt":"program_icon"}}),_c('div',{staticClass:"_text-center program_title mt-1"},[_vm._v(_vm._s(_vm.title))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }